import React,{useEffect, useState} from 'react'
import ProfileInfo from '../components/dashboard/ProfileInfo'
import ProfileInfoForm from '../components/dashboard/ProfileInfoForm'
import EnrollmentDetailForm from '../components/dashboard/EnrollmentDetailForm'
import CourseFeeSection from '../components/dashboard/CourseFeeSection'
import FamilyInfo from '../components/dashboard/FamilyInfo'
import AddressInfo from '../components/dashboard/AddressInfo'
// import UploadDocument from '../components/dashboard/UploadDocument'
import { StateUseContext } from '../context/UserDetailContext'
// import Toast from '../components/common/Toast'
// import { Link } from 'react-router-dom'
import StudyMaterial from '../components/dashboard/StudyMaterial'
import VanSubscribeBanner from '../components/vansubscription/VanSubscriptionBanner'


const Dashboard = () => {
  const {userDetail,feeDetail,txCashWinnerEligible,fetchTxCashWinnerEligible,vanSubscriptionDetail,fetchVanSubscriptionDetail} = StateUseContext();
  const {profile_picture,id:userId,form_num,is_study_material,country_id} = userDetail || {};
  const [activeTab, setActiveTab] = useState(0);
  const {subscriptionDetail}= vanSubscriptionDetail || {};

  useEffect(() => {
    if(form_num){
      fetchTxCashWinnerEligible(form_num)
      fetchVanSubscriptionDetail()
    }
    
  },[form_num])


  const handleNextTab = () => {
    if (activeTab < 5) { 
      setActiveTab(activeTab + 1);
    }
  };

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };



  return (
    <>
      <ProfileInfo/>
      {!profile_picture && 
      <div className="container">
      <p className="text-info border-3 mt-4 mb-2 border-start ps-2 bg-light py-2 mb-4 border-info fw-semibold" style={{fontSize:'15px'}}>  
        <b>Note: </b> PLEASE UPLOAD A VALID PASSPORT-SIZED PHOTOGRAPH FOR THE CANDIDATE'S ID CARD.</p>
      </div>
      }

    {
       (subscriptionDetail?.status ===1 && country_id ===6)  &&  (
          <div className="container mt-3">
            <div className="row">
              <div className="col-lg-12">
                <VanSubscribeBanner vanSubscriptionDetail={vanSubscriptionDetail}/>
              </div>
            </div>
        </div>
        )
      } 

      {/* {txCashWinnerEligible?.status && 
        <div className="container position-relative mt-3 mb-2">
          <div className="row">
            <div className="col-lg-12">
              <Toast
                toastDetail={`Congratulations you have won
                  cash reward of  INR ${txCashWinnerEligible?.cash_prize} amount based on your TALLENTEX Overseas 2023 Performance.`}>
                  &nbsp; <Link to={`/student/student-bank-detail/${userId}`} className="btn btn-primary btn-sm">Click here to fill Bank Details</Link>
                </Toast> 
            </div>
          </div>
        </div>
      </div>
      } */}
      
 

      {/* Tabs Navigation  */}
     <div className="container mt-4 mb-5">
        <div className="row">
            <div className="col-md-12 dash-tab dash-tab-navigation">
                  <nav>
                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                            <button className={`nav-link ${activeTab === 0 ? 'active' : ''}`} id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-selected={activeTab === 0 ? 'true' : 'false'} onClick={() => handleTabClick(0)}>Profile Info</button>
                            <button className={`nav-link ${activeTab === 1 ? 'active' : ''}`} id="nav-enrollment-tab" data-bs-toggle="tab" data-bs-target="#nav-enrollment" type="button" role="tab"  aria-selected={activeTab === 1 ? 'true' : 'false'} onClick={() => handleTabClick(1)}>Enrollment Info</button>
                            <button className={`nav-link ${activeTab === 2 ? 'active' : ''}`} id="nav-course-tab" data-bs-toggle="tab" data-bs-target="#nav-course" type="button" role="tab"  aria-selected={activeTab === 2 ? 'true' : 'false'} onClick={() => handleTabClick(2)}>Course Fee Info</button>
                            <button className={`nav-link ${activeTab === 3 ? 'active' : ''}`} id="nav-family-tab" data-bs-toggle="tab" data-bs-target="#nav-family" type="button" role="tab"  aria-selected={activeTab === 3 ? 'true' : 'false'} onClick={() => handleTabClick(3)}>Family Info</button>
                            <button className={`nav-link ${activeTab === 4 ? 'active' : ''}`} id="nav-address-tab" data-bs-toggle="tab" data-bs-target="#nav-address" type="button" role="tab"  aria-selected={activeTab === 4 ? 'true' : 'false'} onClick={() => handleTabClick(4)}>Address Info</button>
                            {is_study_material===1 && (
                                <button className={`nav-link ${activeTab === 5 ? 'active' : ''}`} id="nav-studymaterial-tab" data-bs-toggle="tab" data-bs-target="#nav-studymaterial" type="button" role="tab"  aria-selected={activeTab === 4 ? 'true' : 'false'} onClick={() => handleTabClick(5)}>Study Material</button>
                            )}
                            {/* <button className={`nav-link ${activeTab === 5 ? 'active' : ''}`} id="nav-document-tab" data-bs-toggle="tab" data-bs-target="#nav-document" type="button" role="tab"  aria-selected={activeTab === 5 ? 'true' : 'false'} onClick={() => handleTabClick(5)}>Document</button> */}
                        </div>
                  </nav>

                  <div className="tab-content" id="nav-tabContent">
                      {/* ######## Profile Info Start ######## */}
                        <div className={`tab-pane pt-2  fade ${activeTab === 0 ? 'show active' : ''}`} id="nav-profile" role="tabpanel" >
                            <ProfileInfoForm  nexTabChange={handleNextTab}/>
                        </div>
                        {/* ######## Enrollment Detail Start ######## */}
                        <div className={`tab-pane pt-2  fade ${activeTab === 1 ? 'show active' : ''}`} id="nav-enrollment" role="tabpanel" >
                            <EnrollmentDetailForm nexTabChange={handleNextTab}/>
                        </div>
                        {/* ######## Course Fee Info Tab Start ######## */}
                        <div className={`tab-pane pt-2  fade ${activeTab === 2 ? 'show active' : ''}`} id="nav-course" role="tabpanel">
                             <CourseFeeSection nexTabChange={handleNextTab}/>
                        </div>
                        {/* ######## Family Info Tab Start ######## */}
                        <div className={`tab-pane pt-2  fade ${activeTab === 3 ? 'show active' : ''}`} id="nav-family" role="tabpanel">
                            <FamilyInfo nexTabChange={handleNextTab}/>
                        </div>
                        {/* ######## Address Info Tab Start ######## */}
                        <div className={`tab-pane pt-2  fade ${activeTab === 4 ? 'show active' : ''}`} id="nav-address" role="tabpanel">
                            <AddressInfo nexTabChange={handleNextTab}/>
                        </div>
                        <div className={`tab-pane pt-2  fade ${activeTab === 5 ? 'show active' : ''}`} id="nav-studymaterial-ta" role="tabpanel">
                            <StudyMaterial feeDetail={feeDetail !==undefined && feeDetail} userDetail={userDetail !==undefined && userDetail}/>
                        </div>
                        {/* ######## Document Info Tab Start ########  */}
                        {/* <div className={`tab-pane pt-2 fade ${activeTab === 5 ? 'show active' : ''}`} id="nav-document" role="tabpanel">
                          <UploadDocument nexTabChange={handleNextTab}/>
                        </div> */}
                  </div>

                   {/* <button onClick={handleNextTab} className="btn btn-default mt-3"> Next </button>  */}
                </div>
            </div>
        </div>
    </>
  )
}

export default Dashboard